// extracted by mini-css-extract-plugin
module.exports = {"logo":"style-module--logo--1X3NY"};